<template>
  <v-text-field
    :label="item.label"
    v-model="item.value"
    :rules="rulesValidation"
    :maxlength="item.maxlength ? item.maxlength: 1000"
    :counter="item.maxlength ? item.maxlength : false"
    :disabled="!updateTrigger || disabled || item.readonly"
    dense
    hide-details="auto"
    :solo="suTable"
    :flat="suTable"
    :outlined="!suTable"
    v-if="showItem"
    :title="item.value"
    :reverse="reverse"
    @change=onChange>
  </v-text-field>
</template>

<script>
  import { validazioni } from '@/mixins/validazioni.js'
  
  export default {
    name: 'testo',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: { type: Number, default: 1 },
      index: Number,
      suTable: { type: Boolean, default: false },
      reverse: { type: Boolean, default: false }
    },
    data: (vm) => ({
    }),
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return  _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      }
    },
    methods: {
      onChange(value) {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value, index: this.index })
      }
    }
  }
</script>